export const AGUARDANDO = 'AGUARDANDO';
export const CONCLUIDO = 'CONCLUIDO';
export const EM_ANDAMENTO = 'EM_ANDAMENTO';
export const PENDENTE = 'PENDENTE';
export const RECUSADO = 'RECUSADO';
export const EXPIRADO = 'EXPIRADO';
